import { useEffect } from 'react';
import { useAnalytics } from '../../hooks/useAnalytics';

// this will only mount and fire a PageView event via the CMS on campaing pages
export const TorkTracking = ({
	sendConversionOnLoad,
}: {
	initTracking?: boolean;
	sendConversionOnLoad?: boolean;
}): JSX.Element | null => {
	const { sendTorkEvent } = useAnalytics();

	useEffect(() => {
		if (sendConversionOnLoad) sendTorkEvent('PageView');
	}, []);

	return null;
};
